import React from "react";
import { Pagination } from "@mui/material";
const AppPagination = ({ setPage, totalPages }) => {
  const handleChange = (page) => {
    setPage(page);
  };

  return (
    <div className="pt-5 pb-5 flex justify-center">
      <Pagination
        onChange={(e, page) => handleChange(page - 1)}
        count={totalPages}
        variant="outlined"
        color="primary"
      />
    </div>
  );
};

export default AppPagination;
